export default __webpack_public_path__ + "static/media/edufyOne.358f99b7.png";